import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { ImagesService } from '../_services/images.service';
import { StoreService } from '../_services/store.service';
import { CookieService } from 'ngx-cookie-service';
import { Lightbox } from 'ngx-lightbox';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-image-bank',
    templateUrl: './image-bank.component.html',
    styleUrls: ['./image-bank.component.css'],
})
export class ImageBankComponent implements OnInit {
    imagesArray: any[] = [];
    allImages: any[] = [];
    selectedImage: any;
    imageBase64: any;

    storeId: any;
    cookieStore: any;
    selectedStore: any;

    role: any;
    routeRole: any;

    constructor(
        public loader: LoadingBarService,
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public globals: Globals,
        public fb: FormBuilder,
        public notificationService: NotificationService,
        public _imagesService: ImagesService,
        public _storeService: StoreService,
        public cookieService: CookieService,
        public lightbox: Lightbox,
        public confirmationService: ConfirmationService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;
    }

    ngOnInit() {
        this.getStore(this.storeId);
        this.getImages(this.storeId);
    }

    public getStore(id) {
        this._storeService.getStoreById(id).subscribe((data: any) => {
            // console.log(data);
            this.selectedStore = data;
        });
    }

    public getImages(id) {
        this.imagesArray = [];
        this._imagesService.getAllStoreImages(id).subscribe((data: any) => {
            this.allImages = data;
            data.forEach((element) => {
                const obj = {
                    imageUrl: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                    src: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                    thumb: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                    value: element,
                };
                this.imagesArray.push(obj);
            });
        });
    }

    // Uploading
    public onFileChange(event) {
        for (let i = 0; i < event.target.files.length; i++) {
            const file: File = event.target.files[i];
            const myReader: FileReader = new FileReader();
            const that = this;
            myReader.onloadend = function(loadEvent: any) {
                const fileObj = {
                    fileName: event.target.files[i].name,
                    imageBase64: loadEvent.target.result,
                    itemCategoryId: null,
                    itemFeaturedItemId: null,
                    itemImageItemId: null,
                    storeFeaturedImageStoreId: null,
                    storeId: that.storeId,
                    storeLogoStoreId: null,
                };
                that.imageBase64 = fileObj;
                that.uploadImage(fileObj);
            };
            myReader.readAsDataURL(file);
        }
    }

    public uploadImage(fileObj) {
        this._imagesService.uploadImageToImageBank(fileObj).subscribe((data: any) => {
            this.imagesArray = [];
            this.getImages(this.storeId);
            this.notificationService.notify(
                'success',
                'Image Uploaded',
                'Image Successfully Uploaded',
                'top',
                'right'
            );
        });
    }

    open(index: number): void {
        // console.log('this.imagesArray', this.imagesArray);
        // open lightbox
        this.lightbox.open(this.imagesArray, index, {
            centerVertically: true,
            disableScrolling: true,
            showImageNumberLabel: true,
        });
    }

    close(): void {
        // close lightbox programmatically
        this.lightbox.close();
    }

    imageDeleteEvent(e) {
        // console.log('image delete event', e);

        const imgs = this.allImages.slice(0);

        imgs.splice(
            imgs.findIndex(function(i) {
                return i.id === e.id;
            }),
            1
        );

        this.allImages = imgs;

        // console.log(imgs);
        // console.log(this.allImages);
    }

    deleteImage(image) {
        // console.log('Image to delete - ', image);
        this.confirmationService.confirm({
            message:
                'Are you sure that you want to delete this image? It will be completely removed from the system',
            accept: () => {
                this._imagesService.deleteImage(image.value.id, this.storeId).subscribe((data: any) => {
                    this.notificationService.notify(
                        'success',
                        'Image Deleted',
                        'Image has successfully been deleted',
                        'top',
                        'right'
                    );
                    this.getImages(this.storeId);
                });
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/image-bank/image-bank.component.ts